import genericStore from "../generic_store";
import {config} from "./../../config/constants.js";
import axios from "axios";
export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "liquidations",
        object: "liquidation",
        header: [
            { text: "Total", value: "total" },
            { text: "Porcentaje Comisión", value: "commission_percentage" },
            { text: "Comisión", value: "commission" },
            { text: "Total a Liquidar", value: "total_to_liquidate" },
            { text: "Total a Liquidar en coins", value: "coins_to_host" },
            { text: "Mes", value: "month" },
            { text: "Año", value: "year" },
            { text: "CBU/Alias", value: "cbu_alias" },
            { text: "Spots", value: "spot_id" },
            { text: "Host", value: "user_id" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        options: {
          sortBy: ["_id"],
          sortDesc: [false],
        },
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions,
        liquidate({ commit, state }, data) {
            return new Promise((resolve, reject) => {
              commit("request");
              axios
                .post(config.api_url + 'liquidate',data)
                .then((response) => {
                  commit("success");
                  resolve(response.data);
                })
                .catch((error) => {
                  console.log(error);
                  commit("error");
                  reject(error.response.data);
                });
            });
          },
    },
    getters: {
        ...genericStore.getters
    }
};
